import { render } from "./AnnouncementCreateForm.vue?vue&type=template&id=d9f5a2f2&scoped=true"
import script from "./AnnouncementCreateForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementCreateForm.vue?vue&type=script&lang=js"

import "./AnnouncementCreateForm.vue?vue&type=style&index=0&id=d9f5a2f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f5a2f2"]])

export default __exports__